import { IInstitutionAttribute } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { InstitutionAttributeDB } from 'src/app/common/repository/databases';
import { QueryService } from 'src/app/shared/services/query/query.service';

@Injectable({
  providedIn: 'root',
})
export class InstitutionAttributeService {
  constructor(private _queryService: QueryService) {}

  public async loadInstitutionAttributes(institutionId: string): Promise<IInstitutionAttribute[]> {
    if (!institutionId) {
      return [];
    }
    const institutionAttributes =
      (await this._queryService.search<IInstitutionAttribute>(
        { query: `institutionId:${institutionId}` },
        InstitutionAttributeDB
      )) || [];

    return institutionAttributes;
  }

  public async getCorrespondenceTypeForInstitutionId(institutionId: string): Promise<string | null> {
    const attributes = await this.loadInstitutionAttributes(institutionId);
    if (attributes.length === 0) {
      return null;
    }
    return attributes.find(attribute => attribute.attributeName === 'Korrespondenzart')?.value;
  }
}
